import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function More({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path
                d="M3 3V2C2.44772 2 2 2.44772 2 3H3ZM10 3H11C11 2.44772 10.5523 2 10 2V3ZM10 10V11C10.5523 11 11 10.5523 11 10H10ZM3 10H2C2 10.5523 2.44772 11 3 11V10ZM3 3V4H10V3V2H3V3ZM10 3H9V10H10H11V3H10ZM10 10V9H3V10V11H10V10ZM3 10H4V3H3H2V10H3Z"
                fill={color}/>
            <path
                d="M3 14V13C2.44772 13 2 13.4477 2 14H3ZM10 14H11C11 13.4477 10.5523 13 10 13V14ZM10 21V22C10.5523 22 11 21.5523 11 21H10ZM3 21H2C2 21.5523 2.44772 22 3 22V21ZM3 14V15H10V14V13H3V14ZM10 14H9V21H10H11V14H10ZM10 21V20H3V21V22H10V21ZM3 21H4V14H3H2V21H3Z"
                fill={color}/>
            <path
                d="M14 3V2C13.4477 2 13 2.44772 13 3H14ZM21 3H22C22 2.44772 21.5523 2 21 2V3ZM21 10V11C21.5523 11 22 10.5523 22 10H21ZM14 10H13C13 10.5523 13.4477 11 14 11V10ZM14 3V4H21V3V2H14V3ZM21 3H20V10H21H22V3H21ZM21 10V9H14V10V11H21V10ZM14 10H15V3H14H13V10H14Z"
                fill={color}/>
            <path
                d="M14 14V13C13.4477 13 13 13.4477 13 14H14ZM21 14H22C22 13.4477 21.5523 13 21 13V14ZM21 21V22C21.5523 22 22 21.5523 22 21H21ZM14 21H13C13 21.5523 13.4477 22 14 22V21ZM14 14V15H21V14V13H14V14ZM21 14H20V21H21H22V14H21ZM21 21V20H14V21V22H21V21ZM14 21H15V14H14H13V21H14Z"
                fill={color}/>
        </svg>
    );
}

export default More;
